import React from 'react';

import { flagStyles } from '../settings';

const SvgTH = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5160px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgTH;
